import { useState, useEffect } from 'react';
import supabase from '../lib/supabase';

export default function useStreak(user) {
  const [streak, setStreak] = useState(0);

  useEffect(() => {
    if (!user) return;
    updateStreak(user.id);
  }, [user]);

  async function updateStreak(userId) {
    const { data } = await supabase
      .from('profiles')
      .select('streak_count, last_study_date')
      .eq('id', userId)
      .single();

    if (!data) return;

    const today = new Date().toISOString().slice(0, 10);
    const last = data.last_study_date;

    // Already updated today — just show current streak
    if (last === today) {
      setStreak(data.streak_count || 0);
      return;
    }

    // Studied yesterday — increment streak
    const yesterday = new Date(Date.now() - 86400000).toISOString().slice(0, 10);
    const newStreak = last === yesterday ? (data.streak_count || 0) + 1 : 1;

    await supabase
      .from('profiles')
      .update({ streak_count: newStreak, last_study_date: today })
      .eq('id', userId);

    setStreak(newStreak);
  }

  return streak;
}
